<template>
  <div id="app">
    <div id="nav"></div>
    <router-view />
  </div>
</template>

<script>
export default {
  data () {
    return {
      installBtn: 'none',
      installer: undefined
    }
  },

  created () {
    let installPrompt
    window.addEventListener('beforeinstallprompt', e => {
      e.preventDefault()
      installPrompt = e
      this.installBtn = 'block'
    })

    this.installer = () => {
      this.installBtn = 'none'
      installPrompt.prompt()
      installPrompt.userChoice.then(result => {
        if (result.outcome === 'accepted') {
          // PWA Installed case
        } else {
          console.error('Failed to install Portfolio tracker PWA')
        }
      })
    }
  }
}
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background-color: $color-body-bg;
  font-size: 1rem;
}
</style>
